<template>
  <v-container class="contract-container pa-0">
    <!-- 캡쳐시 화면 전체 덮는 레이어 -->
    <div v-if="captureMode" class="cover"></div>

    <!-- 동의서 내용 -->
    <div ref="capture">
      <h3 class="text-center py-4 mt-8">대금지급 위임 동의서</h3>

      <!-- 동의서 본문 -->
      <section class="px-4">
        <div class="delegation-section mb-6">
          <h4>□ 위임을 하는 자(위임인)</h4>
          <table class="delegation-table">
            <tr>
              <td width="30%">상호명</td>
              <td width="70%">{{ me.store.name }}</td>
            </tr>
            <tr>
              <td>사업자등록번호</td>
              <td>{{ me.store.businessLicenseNumber }}</td>
            </tr>
            <tr>
              <td>주소</td>
              <td>{{ me.store.address1 }}</td>
            </tr>
            <tr>
              <td>대표자</td>
              <td>{{ me.name }}</td>
            </tr>
          </table>
        </div>

        <div class="delegation-section mb-6">
          <h4>□ 위임을 받는 자(대리인)</h4>
          <table class="delegation-table">
            <tr>
              <td width="30%">회사명</td>
              <td width="70%">주식회사 펀다에이아이</td>
            </tr>
            <tr>
              <td>사업자등록번호</td>
              <td>724-87-00107</td>
            </tr>
            <tr>
              <td>주소</td>
              <td>서울시 금천구 가산디지털1로 70, 5층 514호(가산동, 호서대벤처타워)</td>
            </tr>
            <tr>
              <td>대표자</td>
              <td>이영민</td>
            </tr>
          </table>
        </div>

        <div class="delegation-content mb-6">
          <p>
            1. 본인은 {{ $moment().format('YYYY년 MM월 DD일') }} (주)펀다에이아이의 BNPL 상품인 AI 장사비서
            3개월 집중관리 프로그램 신청을 통해 모집된 금액을 아래 업체의 입금계좌로 입금하여 주시기
            바랍니다.
          </p>
          <p class="mt-4">
            본인(위임인)은 위임을 받는 자(대리인)에게 아래 각 호를 위한 일체의 권한을 위임하고,
            문제발생 시 어떠한 이의도 제기하지 않겠습니다.
          </p>
        </div>

        <div class="delegation-section mb-6">
          <h4>2. 대금지급을 위한 계좌정보</h4>
          <table class="delegation-table">
            <tr>
              <td width="40%">업체명</td>
              <td width="60%">㈜파워텔레콤</td>
            </tr>
            <tr>
              <td>은행명</td>
              <td>국민은행</td>
            </tr>
            <tr>
              <td>계좌번호</td>
              <td>759901-00-137980</td>
            </tr>
            <tr>
              <td>예금주<br />(업체명과 동일해야함)</td>
              <td>㈜파워텔레콤</td>
            </tr>
            <tr>
              <td>금액 총액</td>
              <td>1,749,000원</td>
            </tr>
          </table>
        </div>

        <div class="delegation-content mb-6">
          <p>3. 관련 계약 : AI 장사비서 3개월 집중관리 프로그램 계약에 의거</p>
        </div>
      </section>

      <!-- 서명란 -->
      <section class="pt-4 text-center mb-8">
        <p>{{ $moment().format('YYYY년 MM월 DD일') }}</p>
        <p>
          성명 <b>{{ me.name }}</b>
        </p>

        <p class="mt-4 mb-6">위 대금지급위임 동의서의 내용을 이해하고 동의합니다.</p>

        <ContractAgreeSign ref="sign" @sign="sign" />
      </section>
    </div>

    <!-- 하단 영역 -->
    <v-footer fixed class="pa-0 ma-0">
      <v-layout>
        <v-btn
          block
          depressed
          tile
          color="primary"
          height="52"
          :disabled="isSubmitLoading || showErrorMode"
          :loading="isSubmitLoading"
          @click="submit"
        >
          <b class="font-size--18 font-weight-black white--text">다음</b>
        </v-btn>
      </v-layout>
    </v-footer>
  </v-container>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { sleep } from '@/util'
import html2canvas from 'html2canvas'

export default {
  components: {
    ContractAgreeSign: () => import('@/components/loan/contract/input/ContractAgreeSign.vue'),
  },
  props: {
    loan: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      agreeForm: {
        sign: false,
      },
      formSource: {
        signature: null,
        image: null,
        contract: null,
        term: null,
      },
      isSubmitLoading: false,
    }
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapState('ui', ['captureMode', 'showErrorMode']),
    contractAgreementForm() {
      return {
        offer: this.loan?.offer?.uuid,
        contract: this.formSource.contract?.uuid,
        term: this.formSource.term?.uuid,
        isAgreed: true,
        signature: this.formSource.signature,
        image: this.formSource.image,
      }
    },
  },
  async created() {
    // 기본계약서
    this.formSource.contract = await this.getContractCurrent()

    // 대금지급위임 동의서 약관
    this.formSource.term = await this.getContractTermsCode({
      code: 'BNPL_JANGSA3_PAYMENT_DELEGATION',
    })
  },
  methods: {
    ...mapActions('loan', []),
    ...mapMutations('ui', ['setCaptureMode']),
    ...mapActions('ui', ['activateErrorMode']),
    ...mapActions('agreement', [
      'getContractCurrent',
      'getContractTermsCode',
      'addContractAgreements',
    ]),

    sign(signature) {
      this.agreeForm.sign = true
      this.formSource.signature = signature
    },

    async validate() {
      if (!this.agreeForm.sign) {
        await this.$swal.basic.alert('서명을 완료해주세요.')
        this.activateErrorMode()
        return false
      }
      return true
    },

    async capture() {
      await sleep(1500)

      const element = this.$refs.capture
      const canvas = await html2canvas(element, {
        x: 0,
        y: 0,
        scale: 1,
      })

      const blob = await new Promise((resolve) => canvas.toBlob(resolve))
      this.formSource.image = blob
    },

    async submit() {
      if (!(await this.validate()) || this.isSubmitLoading) return

      try {
        this.isSubmitLoading = true
        this.setCaptureMode(true)
        await this.capture()

        // 계약서 저장
        await this.addContractAgreements(this.contractAgreementForm)

        // 위임동의서 완료 이벤트 발생
        this.$emit('delegation-complete')
      } finally {
        this.setCaptureMode(false)
        this.isSubmitLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.contract-container {
  position: relative;

  .contract-notice {
    background-color: #f4faff;
    padding: 20px;
    font-size: 16px;
    line-height: 1.5;
    color: #333333;
  }

  .cover {
    background-color: transparent;
    position: fixed;
    width: 100%;
    height: 120%;
    top: 0;
    z-index: 3;
    touch-action: none;
  }
}

section {
  margin: 30px 0;
}

.delegation-section {
  h4 {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 16px;
  }
}

.delegation-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd;

  td {
    padding: 12px;
    border: 1px solid #ddd;
    font-size: 14px;
    line-height: 1.4;

    &:first-child {
      background-color: #f8f9fa;
      font-weight: 500;
    }
  }
}

.delegation-content {
  p {
    font-size: 14px;
    line-height: 1.6;
    color: #333;
  }
}
</style>
